import React, { useState, useRef } from "react";
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import * as _ from "lodash"
import config from "../../config.json";
import Scanner from "./Components/Scanner";
import { _getLink } from "../../utils/scannerApi"
import "./styles.css";
import { useEffect } from "react";
import { _setAccessTokenHeader } from "../../utils/HandleApi"
import {
  deviceType,
  versionNumber,
} from "network-helper";
import { useAppState } from '../../contexts/appState';

import Loader from "../Loader";
import { useHistory } from "react-router-dom";

const STANDARD_ERROR_MESSAGE = "Something went wrong. Please try again.";

const symptomCheckerConfig = {
  age: "",
  relation: "self",
  gender: "",
  source_user_id: "",
  source_id: "JhhWebApp",
  workflow_id: "covid_survey_v4",
}
// JhhWebApp

export const gendersSymptomsChecker = [
  "",
  "Male",
  "Female"
]
const ReadBarcode = () => {
  const [result, setResult] = useState(null);
  const history = useHistory()
  const [{ }, dispatch] = useAppState()

  useEffect(() => {
    dispatch({ type: 'UPDATE_HAMBURGER_MENU_STATUS', menuStatus: true })
  }, [])

  useEffect(() => {
    getSCLink();
  }, [result])

  const getSCLink = async () => {
    if (result) {
      try {
        let res = await _getLink({ barcode_reference: result });
        if (!res || !res.status || res.status === "error") {
          let errorMessage = STANDARD_ERROR_MESSAGE;
          if (res.message) {
            errorMessage = res.message;
          }
          var APIError = new Error(errorMessage);
          APIError.type = "custom";
          throw (APIError);
        }

        let symptomChecker = _.get(res, "contents", {});

        let age, gender, jhh_token;
        ({ age, gender, jhh_token } = symptomChecker);

        let url =
          `/workflow?` +
          `hideHeader=false` +
          `&hideHamburgerFromHeader=true` +
          `&age=${age}` +
          `&relation=${symptomCheckerConfig.relation}` +
          `&version_number=${versionNumber}` +
          `&gender=${gendersSymptomsChecker[Number(gender)]}` +
          `&source_user_id=${encodeURIComponent(jhh_token)}` +
          `&source_id=${symptomCheckerConfig.source_id}` +
          `&workflow_id=${symptomCheckerConfig.workflow_id}` +
          `&device_type=${deviceType}` +
          `&redirectTo=/`;

        toast.success("Please wait. Redirecting you to Symptom checker", {});

        history.replace(url);
      } catch (err) {
        toast.error(err.message, {});
        setTimeout(() => {
          setResult("");
        }, 700);
      }
    }
  }


  const onComplete = async (barcode) => {
    setResult(barcode);
  }

  return (
    <div className="barcode-scanner">
      {result &&
        <div className="loader-container">
          <Loader loadingCount={result.length > 0 ? 1 : 0} />
        </div>}
      <div className="barcode-label"> Scan your barcode </div>
      <div className="container">
        {result && <p>{result}</p>}
        {<Scanner onDetected={onComplete} scannedBarcode={result} />}
      </div>
      <ToastContainer
        position="bottom-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}
export default ReadBarcode;